export const DOWNLOAD_TEMPLATE_CONFIG = {
  DOWNLOAD_TEMPLATE: {
    endPoint: 'templateDownload',
    method: 'POST'
  }
};
